import { Component } from '@angular/core';

@Component({
    selector: 'app-awards-and-accreditations',
    templateUrl: './awards-and-accreditations.component.html',
    styleUrls: ['../../invest/home/invest.component.css', '../../../assets/styles/new-styles.css']
})
export class AwardsAndAccreditationsComponent {}
